<template>
    <div class="card register-card">

        <div class="card-header">
            <p class="card-header-title">{{ trans.element.register }}</p>
        </div>

        <div class="card-content field-label-container">
            <form method="POST" id="register_form" @submit.prevent="submit"
                  @input="clearValidation" :action="action" novalidate
            >

                <slot><!--CSRF token--></slot>

                <div class="field is-horizontal is-required">
                    <label for="name" class="field-label is-normal">
                        {{ trans.element.name }}
                    </label>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input
                                    id="name"
                                    v-model="form.name"
                                    class="input"
                                    :class="[errors.name ? 'is-danger' : '']"
                                    type="text"
                                    name="name"
                                    required
                                    autocomplete="name"
                                    autofocus
                                    :disabled="waiting"
                                    :placeholder="trans.placeholder.name"
                                >
                            </div>
                            <p v-show="errors.name" class="help is-danger">
                                {{ errors.name }}
                            </p>
                        </div>
                    </div>
                </div>

                <div class="field is-horizontal is-required">
                    <label for="email" class="field-label is-normal">
                        {{ trans.element.email }}
                    </label>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input
                                    id="email"
                                    v-model="form.email"
                                    class="input"
                                    :class="[errors.email ? 'is-danger' : '']"
                                    type="email"
                                    name="email"
                                    required
                                    autocomplete="email"
                                    :disabled="emailIsDiasabled"
                                    :title="emailTitle"
                                    :placeholder="trans.placeholder.email"
                                >
                            </div>
                            <p v-show="errors.email" class="help is-danger">
                                {{ errors.email }}
                            </p>
                        </div>
                    </div>
                </div>

                <div class="field is-horizontal">
                    <label for="tel" class="field-label is-normal">
                        {{ trans.element.tel }}
                    </label>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input
                                    id="tel"
                                    v-model="telRaw"
                                    class="input"
                                    :class="[errors.tel ? 'is-danger' : '']"
                                    type="tel"
                                    name="tel"
                                    required
                                    autocomplete="off"
                                    :placeholder="trans.placeholder.tel"
                                >
                            </div>
                            <p v-show="errors.tel" class="help is-danger">
                                {{ errors.tel }}
                            </p>
                        </div>
                    </div>
                </div>

                <div class="field is-horizontal">
                    <label for="company" class="field-label is-normal">
                        {{ trans.element.company }}
                    </label>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input
                                    id="company"
                                    v-model="form.company"
                                    class="input"
                                    :class="[errors.company ? 'is-danger' : '']"
                                    type="text"
                                    name="company"
                                    :placeholder="trans.placeholder.company"
                                >
                            </div>
                            <p v-show="errors.company" class="help is-danger">
                                {{ errors.company }}
                            </p>
                        </div>
                    </div>
                </div>

                <div class="field is-horizontal is-required">
                    <label for="password" class="field-label is-normal">
                        {{ trans.element.password }}
                    </label>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input
                                    id="password"
                                    v-model="form.password"
                                    :class="['input', errors.password ? 'is-danger' : '']"
                                    type="password"
                                    name="password"
                                    required
                                    autocomplete="new-password"
                                >
                            </div>
                            <p v-show="errors.password" class="help is-danger">
                                {{ errors.password }}
                            </p>
                        </div>
                    </div>
                </div>

                <div class="field is-horizontal is-required">
                    <label for="password_confirm" class="field-label is-normal">
                        {{ trans.element.confirm_password }}
                    </label>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input
                                    id="password_confirm"
                                    v-model="form.password_confirmation"
                                    class="input"
                                    :class="[errors.password_confirmation ? 'is-danger' : '']"
                                    type="password"
                                    name="password_confirmation"
                                    required
                                    autocomplete="new-password"
                                >
                            </div>
                        </div>
                    </div>
                </div>

                <div class="field is-horizontal">
                    <label class="field-label is-normal"></label>
                    <div class="field-body">
                        <p class="is-size-7" v-html="confirmLicenceLabel"></p>
                    </div>
                </div>

                <div class="field is-horizontal">
                    <label class="field-label is-normal"></label>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input
                                    type="checkbox"
                                    id="confirm_subscribe"
                                    class="is-checkradio is-info is-small"
                                    v-model='form.confirmSubscribe'
                                />
                                <label for="confirm_subscribe" v-html="confirmSubscribeLabel" ></label>
                            </div>
                            <p v-show="errors.confirmSubscribe" class="help is-danger">
                                {{ errors.confirmSubscribe }}
                            </p>
                        </div>
                    </div>
                </div>

                <div class="field is-horizontal button-container">
                    <div class="field-label"></div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <button
                                    type="submit"
                                    class="button is-info"
                                    :class="[isLoading ? 'is-loading' : '']"
                                    :disabled="isLoading || isDisabled"
                                    :title="registerButtonTitle"
                                >
                                    {{ trans.element.register_button }}
                                </button>
                            </div>
                        </div>
                        <p v-show="errors.unexpected" class="help is-danger">
                            {{ errors.unexpected }}
                        </p>
                    </div>
                </div>

                <div class="field is-horizontal">
                    <div class="field-label"></div>
                    <div class="field-body">
                        <p v-html="loginLabel"></p>
                    </div>
                </div>

            </form>
        </div>
    </div>
</template>

<script>
    import { axiosForm } from '../mixins/axiosFormMixin';

    export default {
        mixins: [axiosForm],
        props: {
            email: String,
            is_invite: Boolean,
        },
        data() {
            return {
                form: {
                    name: null,
                    email: this.email,
                    password: null,
                    password_confirmation: null,
                    confirmLicence: true,
                    confirmPersonalData: true,
                    confirmSubscribe: true,
                    tel: '',
                    company: '',
                },
                waiting: null,
                telRaw: '',

                okReport: 'Пользователь зарегистрирован',
                failReport: 'Ошибка регистрации пользователя',
            };
        },
        methods: {
            replaceLink(text, link) {
                 return text.replace(':link', link);
            },
            fillBx24RegisterForm() {
                if (!isBx24Context) {
                    return;
                }

                /*
                 * внутри колбэка this - это не этот компонент, поэтому
                 * дополнительная переменная
                 */
                let thisComponent = this;
                thisComponent.form.name = this.trans.element.loading_from_portal;
                thisComponent.form.email = this.trans.element.loading_from_portal;
                thisComponent.waiting = true;

                new Promise(function (resolve) {
                    BX24.init(() => { resolve(); });
                })
                .then(() => {
                    return new Promise(function (resolve) {
                        BX24.callMethod('user.current', {}, result => resolve(result));
                    });
                })
                .then(result => {
                    thisComponent.form.name = `${result.data().NAME} ${result.data().LAST_NAME}`;
                    thisComponent.form.email = result.data().EMAIL;
                    thisComponent.waiting = null;
                });
            },
            preRequestHandler() {
                let telClear = this.telRaw.replace(/\D/g, "");
                this.form.tel = telClear;
            },
        },
        computed: {
            emailIsDiasabled() {
                let isInvite = this.is_invite;
                let wating = this.waiting;
                return (wating || isInvite);
            },
            emailTitle() {
                let isInvite = this.is_invite;
                if (isInvite) {
                    return this.trans.msg.approach_only_this_email;
                }
                return '';
            },
            confirmLicenceLabel() {
                let license = this.replaceLink(this.trans.element.confirm_licence, agreements.agreement),
                    personal = this.replaceLink(this.trans.element.confirm_personal_data, agreements.agreement_pers);

                return `${license} ${personal}`;
            },
            confirmSubscribeLabel() {
                return this.replaceLink(this.trans.element.confirm_subscribe, agreements.advertising);
            },
            loginLabel() {
                return this.replaceLink(this.trans.element.login_label, this.cancel_route);
            },
            isDisabled() {
                if (!this.form.confirmLicence) {
                    return true;
                }
                if (!this.form.confirmPersonalData) {
                    return true;
                }
                return false;
            },
            // TODO: убрать функцию вместе со всем функционалом проверки согласия
            registerButtonTitle() {
                let isDisabled = this.isDisabled;
                if (isDisabled) {
                    return this.trans.element.confirm_agreement_require;
                }
                return '';
            },
        },
        created() {
            this.fillBx24RegisterForm();
        }
    };
</script>
